import $ from "jquery";
import "slick-carousel";
import _merge from "lodash.merge";
import _template from "lodash.template";

export default {
    init: function () {
        let that = this;
        let slider = $(".slider");

        slider.on("init", function (event, slick) {
            const sliderId = $(event.target).data("slider-id");

            that.refreshSliderDots(sliderId);
            that.refreshSliderArrows(sliderId);
            that.refreshSliderAffected(sliderId);

            $(event.target).removeClass("hidden");

            $(`[data-custom-dot="${sliderId}"]`).on("click", function () {
                slick.goTo($(this).index());
            });

            if (
                $(event.target).data("slider-template") === "info-carousel" ||
                $(event.target).data("slider-template") ===
                    "info-carousel-reverse"
            ) {
                var sliderMenu = $("#slider-menu-" + sliderId);

                $(event.target)
                    .find(".slick-slide")
                    .each(function (i) {
                        var slideName = $(this)
                            .find("[data-slide-name]")
                            .data("slide-name");
                        var buttonHtml =
                            "<div class='mb-2'><span data-target-slider=" +
                            sliderId +
                            " data-target-slide='" +
                            i +
                            "' class='slide-button cursor-pointer text-navy-160 border-b-1 border-transparent hover:border-navy-160'>" +
                            slideName +
                            "</span></div>";
                        sliderMenu.append(buttonHtml);
                    });

                // Scope the click event listener to the current slider instance
                // by targeting the event delegation from the specific sliderMenu
                sliderMenu.on("click", ".slide-button", function () {
                    var targetSlide = $(this).data("target-slide");
                    slick.goTo(targetSlide);
                });

                that.refreshSliderMenu(sliderId);
            }
        });

        $(window).on("resize", function () {
            slider.each(function () {
                const sliderId = $(this).data("slider-id");
                that.refreshSliderArrows(sliderId);
                that.refreshSliderDots(sliderId);
            });
        });

        // appendDots: $('.slider-controls__dots'),

        // return;

        slider.each(function () {
            // setup arrows HTML

            const sliderId = slider.data("slider-id");
            // console.log({sliderId})
            let prevArrowHtml = `<button type="button" class="slick-prev">P</button>`;
            let nextArrowHtml = `<button type="button" class="slick-next">N</button>`;
            const $prevArrowTemplate = document.getElementById(
                `prev-arrow-template-${sliderId}`
            );
            const $nextArrowTemplate = document.getElementById(
                `next-arrow-template-${sliderId}`
            );

            if ($($prevArrowTemplate).length) {
                const prevArrowTemplateHtml = $prevArrowTemplate.innerHTML;
                const templateFn = _template(prevArrowTemplateHtml);
                prevArrowHtml = templateFn({ sliderId });
            }
            if ($($nextArrowTemplate).length) {
                const nextArrowTemplateHtml = $nextArrowTemplate.innerHTML;
                const templateFn = _template(nextArrowTemplateHtml);
                nextArrowHtml = templateFn({ sliderId });
            }

            let slickSettings = {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                autoplay: false,
                autoplaySpeed: 2000,
                prevArrow: prevArrowHtml,
                nextArrow: nextArrowHtml,
                customPaging: function (slider, i) {
                    // console.log({slider})
                    const sliderId = $(slider.$slider).data("slider-id");

                    let dotsHtml =
                        '<div class="dot" data-slick-index=' + i + "></div>"; //not utilizing this yet

                    const sliderItemData = slider.$slides
                        .eq(i)
                        .children()
                        .find(".slider__slide")
                        .data();

                    const $dotsTemplate = document.getElementById(
                        `slider-dots-template-${sliderId}`
                    );
                    // console.log({$dotsTemplate}, `slider-dots-template-${sliderId}`)
                    if ($($dotsTemplate).length === 0) {
                        return dotsHtml;
                    }

                    // console.log({sliderItemData})
                    const dotsTemplateHtml = $dotsTemplate.innerHTML;

                    const templateFn = _template(dotsTemplateHtml);
                    dotsHtml = templateFn({ sliderId, data: sliderItemData });

                    return dotsHtml;
                },
            };

            slickSettings.arrows = $(this).data("arrows") ? true : false;
            slickSettings.dots = $(this).data("dots") ? true : false;

            if ($(this).data("slider-settings")) {
                let userSettings = $(this).data("slider-settings"); //JSON.parse(slider.data('slider-settings'));

                slickSettings = _merge(slickSettings, userSettings);
            }

            if (slickSettings.dots === true && !slickSettings.appendDots) {
                const $dotsContainer = $(
                    ".slider-dots",
                    $(this).closest(".slider-container")
                ).not(".slider-dots-custom");

                if ($dotsContainer.length) {
                    slickSettings.appendDots = $dotsContainer;
                }
            }

            if (slickSettings.arrows === true && !slickSettings.appendArrows) {
                const $arrowsContainer = $(this)
                    .closest(".slider-container")
                    .children(".slider-arrows").length
                    ? $(this)
                          .closest(".slider-container")
                          .children(".slider-arrows")
                    : $(this)
                          .closest(".slider-container")
                          .children()
                          .find(".slider-arrows");

                if ($arrowsContainer.length) {
                    slickSettings.appendArrows = $arrowsContainer;
                }
            }

            $(this)
                .slick(slickSettings)

                .on(
                    "beforeChange",
                    function (event, slick, currentSlide, nextSlide) {
                        const sliderId = $(this).data("slider-id");

                        if (
                            $(this).data("slider-before-change") &&
                            typeof window[
                                $(this).data("slider-before-change")
                            ] === "function"
                        ) {
                            window[$(this).data("slider-before-change")](
                                event,
                                slick,
                                currentSlide,
                                nextSlide
                            );
                        }

                        let slidesToScroll = slick.options.slidesToScroll;
                        that.refreshSliderDots(
                            sliderId,
                            nextSlide / slidesToScroll
                        );

                        that.refreshSliderMenu(
                            sliderId,
                            nextSlide / slidesToScroll
                        );

                        if (currentSlide === nextSlide) return;

                        that.refreshSliderAffected(
                            sliderId,
                            nextSlide / slidesToScroll
                        );
                    }
                )
                .on("afterChange", function (slick, currentSlide) {
                    const sliderId = $(this).data("slider-id");

                    setTimeout(function () {
                        that.refreshSliderArrows(sliderId);
                        that.refreshSliderDots(sliderId);
                    }, 1);
                });
        });
    },
    refreshSliderDots: function (sliderId, currentSlideIndex = 0) {
        // const sliderId = $(this).data('slider-id')
        $(`.slider-dots[data-slider-id="${sliderId}"]`).each(function () {
            const $sliderDots = $(this);
            let ulClass = $sliderDots.data("ul-class");
            ulClass = ulClass ? ulClass : "";
            let fixedDotClass = $sliderDots.data("fixed-class");
            fixedDotClass = fixedDotClass ? fixedDotClass : "";
            const inActiveDotClass = $sliderDots.data("inactive-class");
            const activeDotClass = $sliderDots.data("active-class");
            const spacingDotClass = $sliderDots.data("space-class");

            $(`ul`, $sliderDots).addClass(ulClass);
            $(`ul li`, $sliderDots).addClass(fixedDotClass);
            $(`li`, $sliderDots)
                .removeClass(activeDotClass)
                .addClass(inActiveDotClass);
            $(`li:nth-child(${currentSlideIndex + 1})`, $sliderDots)
                .removeClass(inActiveDotClass)
                .addClass(activeDotClass);
            $(`ul li`, $sliderDots)
                .not(":last-child")
                .addClass(spacingDotClass);
        });
    },
    refreshSliderMenu: function (sliderId, currentSlideIndex = 0) {
        $(`.slide-button[data-target-slider="${sliderId}"]`).each(function () {
            if ($(this).data("target-slide") === currentSlideIndex) {
                $(this).addClass("text-navy-400 border-navy-400");
                $(this).removeClass("text-navy-160 border-transparent");
            } else {
                $(this).removeClass("text-navy-400 border-navy-400");
                $(this).addClass("text-navy-160 border-transparent");
            }
        });
    },
    refreshSliderArrows: function (sliderId) {
        const inActiveArrowClass = $(
            `.slider-arrows[data-slider-id="${sliderId}"]`
        ).data("inactive-class");
        const activeArrowClass = $(
            `.slider-arrows[data-slider-id="${sliderId}"]`
        ).data("active-class");

        $(`.slider-arrows[data-slider-id="${sliderId}"] .slick-disabled`)
            .removeClass(activeArrowClass)
            .addClass(inActiveArrowClass);
        $(`.slider-arrows[data-slider-id="${sliderId}"] .slick-arrow`)
            .not(".slick-disabled")
            .removeClass(inActiveArrowClass)
            .addClass(activeArrowClass);
    },
    refreshSliderAffected: function (sliderId, activeSlideIndex = 0) {
        $(`[data-slider-affected="${sliderId}"]`).each(function () {
            const $that = $(this);
            const index = $(this).data("slider-index");

            const inActiveClass = $(this).data("on-inactive-slide-class");
            const inActiveRemoveClass = $(this).data(
                "on-inactive-slide-remove-class"
            );
            const activeClass = $(this).data("on-active-slide-class");
            const activeRemoveClass = $(this).data(
                "on-active-slide-remove-class"
            );

            let inActiveAttributes =
                $(this).data("on-inactive-slide-attributes") || {};
            let activeAttributes =
                $(this).data("on-active-slide-attributes") || {};

            // console.log(inActiveClass)
            $(this).removeClass(inActiveRemoveClass).addClass(inActiveClass);

            $.each(inActiveAttributes, function (key, value) {
                $that.attr(key, value);
            });
            // console.log(index, activeSlideIndex)

            // if($(this).closest('li')[0] === $activeLi[0]) {
            if (index === activeSlideIndex) {
                // console.log('2352')
                $(this)
                    .removeClass(inActiveClass)
                    .removeClass(inActiveRemoveClass);
                $(this).removeClass(activeRemoveClass).addClass(activeClass);

                $.each(activeAttributes, function (key, value) {
                    $that.attr(key, value);
                });
            }
        });
    },
};
